export enum TableMapsToggle {
  HeatMap = 'heatMap',
  Maps = 'maps',
}
